import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center" data-testid="payment-cancel">
      <XCircle size={44} className="text-ink-muted mb-4" />
      <div className="ink-stamp mb-3">Checkout cancelled</div>
      <div className="font-headline uppercase text-3xl sm:text-4xl font-black tracking-tighter">
        No harm done.
      </div>
      <p className="mt-3 font-body italic text-ink-muted max-w-md">
        We didn't charge anything. Come back whenever you're ready — the archives aren't going anywhere.
      </p>
      <div className="mt-6 flex gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-press-red text-paper border-2 border-press-red px-5 py-3 font-mono uppercase text-xs tracking-widest hover:bg-ink hover:border-ink"
          data-testid="payment-cancel-home-btn"
        >
          Return home
        </Link>
      </div>
    </div>
  );
}
